export function getContentsFromTwitter(url, type, timelineElement) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_contents_of_uri_twitter",
        datatype: "json",
        data: {
            "ajax_call_uri": url,
            "ajax_call_id": timelineElement.id,
            "ajax_call_type": type
        },
        success: function (output) {
            handleData(output, timelineElement);
        }
    });
}